// extracted by mini-css-extract-plugin
module.exports = {"container":"_93444fe79c--container--HVCbr","title":"_93444fe79c--title--zqhwA","layout":"_93444fe79c--layout--_uBku"};